/**
 * Rillion Prime API v1.0
 * A REST API endpoint for Role operations.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Detail } from './detail';

export interface ModelError {
  code?: string | null;
  message?: string | null;
  details?: Array<Detail> | null;
}
